export default function LinkdinIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M18 18V12.14C18 9.26 17.38 7.06 14.02 7.06C12.4 7.06 11.32 7.94 10.88 8.78H10.84V7.32H7.66V18H10.98V12.7C10.98 11.3 11.24 9.96 12.96 9.96C14.66 9.96 14.68 11.54 14.68 12.78V17.98H18V18ZM2.26 7.32H5.58V18H2.26V7.32ZM3.92 2C2.86 2 2 2.86 2 3.92C2 4.98 2.86 5.86 3.92 5.86C4.98 5.86 5.84 4.98 5.84 3.92C5.84 2.86 4.98 2 3.92 2Z" fill="#292D36"/>
</svg>
  )
}
